import React, { useEffect, useMemo, useState } from "react";

const formatDay = (day) => {
  if (!day) return "—";
  const date = new Date(day);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleDateString("es-MX", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

const truncateText = (text, max = 88) => {
  const value = String(text || "");
  if (value.length <= max) return value;
  return `${value.slice(0, max)}…`;
};

export default function CriticalItemsBreakdownChart({ breakdown }) {
  const breakdowns = breakdown?.breakdowns || [];
  const [selectedTest, setSelectedTest] = useState(
    breakdown?.defaultTestName || breakdowns[0]?.testName || ""
  );

  useEffect(() => {
    if (breakdown?.defaultTestName) {
      setSelectedTest(breakdown.defaultTestName);
    } else if (breakdowns[0]?.testName) {
      setSelectedTest(breakdowns[0].testName);
    }
  }, [breakdown?.defaultTestName, breakdowns]);

  const activeBreakdown = useMemo(
    () => breakdowns.find((entry) => entry.testName === selectedTest),
    [breakdowns, selectedTest]
  );

  if (!breakdown?.hasData) {
    return (
      <p className="expedientes-dashboard-empty">
        No hay pruebas con desglose de ítems (resultlist) para este paciente.
      </p>
    );
  }

  const maxValue = activeBreakdown?.maxValue || 1;

  return (
    <div className="expedientes-items-wrap">
      <div className="expedientes-items-toolbar">
        <label className="expedientes-items-select-label" htmlFor="critical-test-select">
          Prueba
        </label>
        <select
          id="critical-test-select"
          className="expedientes-items-select"
          value={selectedTest}
          onChange={(event) => setSelectedTest(event.target.value)}
        >
          {breakdowns.map((entry) => (
            <option key={entry.testName} value={entry.testName}>
              {entry.testName}
            </option>
          ))}
        </select>
        {activeBreakdown && (
          <span className="expedientes-items-meta">
            Última sesión: {formatDay(activeBreakdown.testDay)} ·{" "}
            {activeBreakdown.criticalCount} pregunta
            {activeBreakdown.criticalCount === 1 ? "" : "s"} crítica
            {activeBreakdown.criticalCount === 1 ? "" : "s"}
          </span>
        )}
      </div>

      {activeBreakdown && (
        <div className="expedientes-items-chart">
          {activeBreakdown.items.map((item) => (
            <div
              key={`${activeBreakdown.testName}-${item.index}`}
              className={`expedientes-items-row ${item.isCritical ? "expedientes-items-row--critical" : ""}`}
            >
              <div className="expedientes-items-copy">
                <span className="expedientes-items-index">
                  Pregunta {String(Number.isNaN(Number(item.index)) ? item.index : Number(item.index) + 1)}
                </span>
                <span className="expedientes-items-text" title={item.text}>
                  {truncateText(item.text)}
                </span>
              </div>
              <div className="expedientes-items-bar-track">
                <div
                  className={`expedientes-items-bar-fill ${
                    item.isCritical ? "expedientes-items-bar-fill--critical" : ""
                  }`}
                  style={{ width: `${(item.value / maxValue) * 100}%` }}
                />
              </div>
              <span className="expedientes-items-value">{item.value}</span>
            </div>
          ))}
        </div>
      )}

      <p className="expedientes-items-note">
        Se resaltan preguntas con puntaje ≥ 2 o con contenido clínicamente sensible
        (p. ej. ideación suicida o anhedonia).
      </p>
    </div>
  );
}
